"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SegmentClient = void 0;
const tslib_1 = require("tslib");
const models_1 = require("../models");
const crud_client_1 = require("./crud.client");
const query_params_1 = require("./utils/query-params");
const to_date_time_string_1 = require("./utils/to-date-time-string");
class SegmentClient extends crud_client_1.CrudClient {
    constructor() {
        super(...arguments);
        this.entityPath = 'segments';
    }
    getUpdatePayloadModel(segment, method) {
        if (segment.temporary && method === models_1.RequestMethod.Put) {
            throw new Error('Temporary segment does not support update');
        }
        const model = Object.assign(Object.assign(Object.assign({}, segment), (method === models_1.RequestMethod.Put && { updaterId: segment.updaterId, temporary: undefined })), (method === models_1.RequestMethod.Post && { creatorId: segment.creatorId }));
        return new SegmentSaveRequestModel(model);
    }
    getBookmarkedSegments(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/segments/bookmarked`);
            return response.payload;
        });
    }
    getTraffic(projectId, input, from, to) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let url;
            const query = {
                from: (0, to_date_time_string_1.toDateTimeString)(from),
                to: (0, to_date_time_string_1.toDateTimeString)(to),
            };
            if (typeof input === 'string') {
                query.fovCondition = input;
                url = `/v1/projects/${projectId}/segments/traffic`;
            }
            else {
                url = `/v1/projects/${projectId}/segments/${input}/traffic`;
            }
            const response = yield this.httpGet(`${url}?${this.getQueryString(query)}`);
            return response.payload;
        });
    }
    getSegmentStats(projectId, segmentIds, from, to, toCurrency) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let url;
            const params = new URLSearchParams();
            params.append('from', (0, to_date_time_string_1.toDateTimeString)(from));
            params.append('to', (0, to_date_time_string_1.toDateTimeString)(to));
            if (segmentIds instanceof Array) {
                url = `/v1/projects/${projectId}/segments/stats`;
                params.append('segmentIds', segmentIds.join(','));
            }
            else {
                url = `/v1/projects/${projectId}/segments/${segmentIds}/stats`;
            }
            if (toCurrency) {
                params.append('toCurrency', toCurrency);
            }
            const response = yield this.httpGet(`${url}?${params.toString()}`);
            return response.payload;
        });
    }
    getSegmentConditions(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/segments/conditions`);
            return response.payload;
        });
    }
    getSegmentsByGoalIdFOV(projectId, goalId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/segments/by-goal?goalId=${goalId}`);
            return response.payload;
        });
    }
    getDeviceModels(projectId, manufacturer) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/device-models?manufacturer=${manufacturer}`);
            return response.payload;
        });
    }
    getFovDetails(projectId, fov) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/projects/${projectId}/segments/fov-details`, fov);
            return response.payload;
        });
    }
    getSegmentDependencies(projectId, ids) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/segments/dependencies?ids=${ids.join(',')}`);
            return response.payload;
        });
    }
    getPageEvents(projectId, request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/projects/${projectId}/page-events`, request);
            return response.payload;
        });
    }
    findAll({ projectId, text, skip, take, fields, withCount, }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const baseUrl = `/v1/projects/${projectId}/segments`;
            const queryParams = (0, query_params_1.makeQueryParams)({ text, skip, take, fields, withCount });
            const url = `${baseUrl}?${queryParams}`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    checkValidity(projectId, segment) {
        const path = `/v2/projects/${projectId}/segments/check-validity`;
        return this.httpPost(path, { segment }, { throwOnError: true })
            .then(() => undefined)
            .catch(({ response }) => ({ errorCode: response.errorCode, errorMessage: response.errorMessage }));
    }
}
exports.SegmentClient = SegmentClient;
class SegmentSaveRequestModel {
    constructor(segment) {
        this.name = segment.name;
        this.category = segment.category;
        this.fovCondition = segment.fovCondition;
        this.updaterId = segment.updaterId;
        this.creatorId = segment.creatorId;
        this.temporary = segment.temporary;
    }
}
//# sourceMappingURL=segment.client.js.map